import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"

import { store } from "./store"
import App from "./App"

/* Fonts */
import "./design/css/fonts.css"

/* Design system — exact prototype stylesheet (chrome, home, catalog, organization, booking, account, modals) */
import "./design/css/bookify.css"

/* Component helpers not covered by the prototype sheet (loading, network, toast) */
import "./design/css/components.css"

/* Chrome — header and footer */
import "./design/css/header.css"
import "./design/css/footer.css"

/* Splash overlay shown while cities and categories load */
import "./design/css/intro.css"

/* Legal pages — privacy policy and public offer */
import "./design/css/legal.css"

/* Page-specific stylesheets */
import "./design/css/about.css"
import "./design/css/contacts.css"
import "./design/css/help.css"
import "./design/css/partner.css"
import "./design/css/citymodal.css"
import "./design/css/bookings.css"
import "./design/css/gifts.css"
import "./design/css/profile.css"
import "./design/css/notifications.css"
import "./design/css/reviews.css"
import "./design/css/home.css"
import "./design/css/search.css"
import "./design/css/account.css"
import "./design/css/organization.css"

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
    <Provider store={store}>
        <App />
    </Provider>
)
